import React, { useState, useEffect } from "react";
import { Header } from "../wrappers/Header";
import banner from "../assets/img/duyuru_banner.png";
import Footer from "../wrappers/Footer";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { fetchDuyurular } from "../redux/actions/duyurularAction";

// Resim URL'sini oluştur
const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  
  // logo/ ile başlıyorsa public/logo/ ekle
  if (imagePath.startsWith('logo/')) {
    return `https://kuleadmin.kulebblok.com.tr/public/${imagePath}`;
  }
  
  // uploads/ ile başlıyorsa direkt ekle (duyurus veya sakins)
  if (imagePath.startsWith('uploads/')) {
    return `https://kuleadmin.kulebblok.com.tr/${imagePath}`;
  }
  
  // Eğer sadece dosya adı varsa (blog_inner*.png gibi), public/ klasörüne yönlendir
  if (!imagePath.includes('/')) {
    // blog_inner ile başlayan veya genel resim dosyaları için public/ kullan
    if (imagePath.startsWith('blog_inner') || 
        imagePath.match(/\.(png|jpg|jpeg|gif|webp|svg)$/i)) {
      return `https://kuleadmin.kulebblok.com.tr/public/${imagePath}`;
    }
    // Diğer durumlarda uploads/duyurus/ kullan
    return `https://kuleadmin.kulebblok.com.tr/uploads/duyurus/${imagePath}`;
  }
  
  // Diğer durumlarda direkt ekle
  return `https://kuleadmin.kulebblok.com.tr/${imagePath}`;
};

const Duyurular = ({ duyurular }) => {
  const dispatch = useDispatch();
  const [hoveredResident, setHoveredResident] = useState(null);

  const handleMouseEnter = (resident) => {
    setHoveredResident(resident.duyuru_no);
  };

  const handleMouseLeave = () => {
    setHoveredResident(null);
  };

  // İlk yüklemede tüm verileri çek
  useEffect(() => {
    dispatch(fetchDuyurular(null, 1, 999)); // Tüm verileri çek
  }, [dispatch]);

  return (
    <>
      <Header />
      <div className="container">
        <div className="col-12 position-relative ">
          <img className="text-main-img" src={banner} alt="Banner" />
          <div className="text-main-center text-center text-white">
            <h1>Duyurular</h1>
          </div>
        </div>

        <div className="mb-5 mt-5 d-flex flex-wrap justify-content-around">
          {duyurular.map((key, index) => (
            <div
              key={index}
              className="col-lg-4 sakin-main col-md-6 p-md-1 position-relative col-12 mb-3 d-flex justify-content-center align-items-center"
              onMouseEnter={() => handleMouseEnter(key)}
              onMouseLeave={handleMouseLeave}
            >
              {key.image && (
                <img 
                  className="text-main-img duyuru-image" 
                  src={getImageUrl(key.image)} 
                  alt={key.title || 'Duyuru'} 
                  onError={(e) => {
                    e.target.style.display = 'none';
                    console.error('Resim yüklenemedi:', key.image, 'URL:', getImageUrl(key.image));
                  }}
                  onLoad={(e) => {
                    // Resim yüklendiğinde boyut kontrolü
                    const img = e.target;
                    if (img.naturalWidth > 2000 || img.naturalHeight > 2000) {
                      console.warn('Büyük resim tespit edildi:', key.image, img.naturalWidth, 'x', img.naturalHeight);
                    }
                  }}
                />
              )}
              <div
                className={`text-main-center-blog text-white ${
                  hoveredResident === key.duyuru_no ? "hovered" : ""
                }`}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`/duyurular/${encodeURIComponent(
                    key.title.replace(/\s/g, "-")
                  )}`}
                >
                  <div className="content">
                    {" "}
                    <h4>{key.title}</h4>
                    <p>{key.date}</p>
                  </div>
                </a>

                {hoveredResident === key.duyuru_no && (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`/duyurular/${encodeURIComponent(
                      key.title.replace(/\s/g, "-")
                    )}`}
                  >
                    <button className="button-type-two "> Daha Fazla</button>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

Duyurular.propTypes = {
  duyurular: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    duyurular: state.duyurularData.duyurular || [],
  };
};

export default connect(mapStateToProps)(Duyurular);
